function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

import format from 'string-format';
format.extend (String.prototype, {});

import { createApp } from 'vue';
import router from '@/router';
import VueCookies from 'vue3-cookies'


import "@/scss/main.scss";


import App from '@/App.vue'

const app = createApp(App)


//import * as bootstrap from 'bootstrap';
//console.log(bootstrap);


//import "@tabler/core/dist/css/tabler-flags.css";
//import "@tabler/core/dist/css/demo.css";
//import "@tabler/core/dist/js/tabler.js";
//import "@tabler/core/src/js/tabler.js";


ready(function() {
    import('@tabler/core/dist/js/tabler.js').then(function () {
        
    });
    
    //import('@tabler/core/src/js/tabler.js');   
})


//import { Modal } from 'bootstrap';



//import { Popover } from 'bootstrap';

/*
import jQuery from "jquery";
global.$ = jQuery

const $ = jQuery;
window.$ = $;

import "bootstrap"
*/


//import "bootstrap/dist/css/bootstrap.min.css"
//import "bootstrap"

//import { bootstrap } from 'bootstrap';



app.use(router)


app.use(VueCookies, {
    expireTimes: 0,
    path: "",
    domain: "",
    secure: true,
    sameSite: "Strict"
});


// Costum Directives
app.directive('visible', {
  beforeMount(el, binding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
  },
  updated(el, binding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
  }
})


// eslint-disable-next-line no-unused-vars
const rootComponent = app.mount("#app");




// OPTION API
app.config.globalProperties.$ready = ready;
//app.config.globalProperties.$cookies = VueCookies;





